module.exports = __webpack_public_path__ + "media/images/icon-money-9a5d39d7a4c41a70af461a267c3fd20f.png";